module.exports = __webpack_public_path__ + "static/img/3.5ff766e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/3.jpg
// module id = DYsC
// module chunks = 0